import React from 'react';
import PropTypes from 'prop-types';
import styles from './AreaAndRegionSelector.scss';
import RCUISingleSelect from '../../../shared/components/RCUISingleSelect';

export const calculateCoordinateY = (windowHeight, windowScrollTop, yCoordinateOfDropdownBottom) => {
  if (yCoordinateOfDropdownBottom <= windowHeight) return windowScrollTop;
  const distanceToScroll = yCoordinateOfDropdownBottom - windowHeight;
  const bottomSpacer = 16;
  return windowScrollTop + distanceToScroll + bottomSpacer;
};

const scrollToShowOpenDropdown = (event) => {
  const dropdownElement = event.target;
  if (!dropdownElement) return;
  const windowScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  const yCoordinateOfDropdownBottom = dropdownElement.getBoundingClientRect().bottom;
  const windowHeight = (
    window.innerHeight || document.documentElement.clientHeight
  );

  const coordinateY = calculateCoordinateY(windowHeight, windowScrollTop, yCoordinateOfDropdownBottom);
  window.scrollTo(0, coordinateY);
};

const AreaAndRegionSelector = ({ items, currentAreaAndRegionItem, changeAreaAndRegion }) => (
  <div className={styles.container}>
    <RCUISingleSelect
      options={items}
      placeholder=""
      selectedOption={currentAreaAndRegionItem}
      onUpdate={scrollToShowOpenDropdown}
      onChange={({ value: { areaId, regionId } }) => changeAreaAndRegion(areaId, regionId)}
    />
  </div>
);

const MOBILE_ITEM_PROP_TYPE = PropTypes.shape({
  displayText: PropTypes.string.isRequired,
  value: PropTypes.shape({
    areaId: PropTypes.string.isRequired,
    regionId: PropTypes.string.isRequired,
  }).isRequired,
});

AreaAndRegionSelector.propTypes = {
  items: PropTypes.arrayOf(
    MOBILE_ITEM_PROP_TYPE.isRequired,
  ).isRequired,
  currentAreaAndRegionItem: MOBILE_ITEM_PROP_TYPE.isRequired,
  changeAreaAndRegion: PropTypes.func.isRequired,
};

export default AreaAndRegionSelector;
